<template>
  <!-- element-loading-text="excle导入中，请稍等" -->
  <div class="app-container">
    <el-card class="box-card" v-loading="loading" element-loading-spinner="el-icon-loading">
      <div slot="header" class="clearfix">
        <h3>网站基本信息</h3>
      </div>
      <div class="content">
        <el-form ref="form" :model="form" label-width="150px">
          <el-form-item label="工作地址">
            <el-input v-model="form.officeAddress" :disabled="!isEdit"/>
          </el-form-item>
          <el-form-item label="工厂3地址">
            <el-input v-model="form.factory" :disabled="!isEdit"/>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="form.phone" :disabled="!isEdit"/>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="form.email" :disabled="!isEdit"/>
          </el-form-item>
          <el-form-item label="faceBook链接">
            <el-input v-model="form.facebookLink" :disabled="!isEdit"/>
          </el-form-item>

          <el-form-item label="whatsapp链接">
            <el-input v-model="form.whatsappLink" :disabled="!isEdit"/>
          </el-form-item>
          <el-form-item label="twitter链接">
            <el-input v-model="form.twitterLink" :disabled="!isEdit"/>
          </el-form-item>
          <el-form-item label="instagramLink链接">
            <el-input v-model="form.instagramLink" :disabled="!isEdit"/>
          </el-form-item>

          <el-form-item label="关于我们">
            <vue-editor
              height="500"
              useCustomImageHandler
              @imageAdded="handleImageAdded"
              :disabled="!isEdit"
              v-model="form.aboutus"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" v-if="!isEdit" @click="isEdit=true">修改</el-button>
            <el-button type="success" @click="doEdit" v-if="isEdit">确认修改</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import * as api from "../../api/share.api";
import axios from "axios";
import { constants } from "crypto";
export default {
  data() {
    return {
      loading: false,
      isEdit: false,
      defaultForm: {
        officeAddress: "",
        factory: "",
        phone: "",
        email: "",
        facebookLink: "",
        whatsappLink: "",
        twitterLink: "",
        aboutus: "",
        instagramLink: ""
      },
      form: {}
    };
  },
  components: {
    VueEditor
  },
  created() {
    this.form = this.defaultForm;
    this.initData();
  },
  mounted() {},
  computed: {},
  methods: {
    handleUpload(file, fileList) {
      this.fileList2.push({
        name: file.data,
        url: file.data
      });
    },
    handleRemove(file, fileList) {
      this.fileList2 = this.fileList2.filter(v => v.url != file.url);
    },
    addItem() {
      this.dialogVisible = true;
      this.dialogTitle = "新增";
      this.addForm = this.defaultForm;
    },
    handleEdit(item) {
      this.dialogVisible = true;
      this.dialogTitle = "修改";
      this.addForm = item;
    },
    doEdit(formName) {
      this.httpPost("/backend/contactInfo/upd", this.form).then(resp => {
        if (resp.code == 0) {
          this.$message.success("修改成功", 1000);
          this.isEdit = false;
          this.initData();
          this.dialogVisible = false;
        } else {
          this.$message.error(resp.msg, 2000);
        }
      });
    },
    initData() {
      this.loading = true;
      this.httpPost("/backend/contactInfo/find", {}).then(resp => {
        console.log(resp);
        this.loading = false;
        if (resp.data) {
          this.form = resp.data;
        } else {
          this.isEdit = true;
        }
      });
    },

    onEditSubmit(formName) {
      this.$refs[formName].validate(valid => {
        console.log(valid);
        if (valid) {
          api.updateShareDataById(this.form).then(resp => {
            if (resp.rCode != 0) {
              this.$message.error(resp.msg);
            } else {
              this.dialogVisible = false;
              this.form = {};
              this.$message.success("修改成功");
              this.initData();
            }
          });
          console.log(this.form);
        } else {
          this.$message.error("请检查填写信息是否完整");
          return false;
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleSizeblur(size) {
      this.pquery.size = size;
    },
    handleCurrentblur(page) {
      this.pquery.page = page;
    },
    handleClick(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm("请再次确认是否删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          this.httpPost("/backend/parammeterTag/del", { _id: row._id }).then(
            resp => {
              if (resp.code != 0) {
                this.$message.error("删除失败");
              } else {
                this.initData();
                this.$message.success("删除成功");
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.cell {
  text-align: center;
}
</style>

